import React, { Component } from 'react';
import { InputText } from 'primereact/inputtext';
import { connect } from 'react-redux';
import { Dropdown } from 'primereact/dropdown';
import { InputSwitch } from 'primereact/inputswitch';
import { Toast } from 'primereact/toast';
import Messages from '../../../shared/UI/Messages/Messages';

import { REDIRECT_TO_URL, HASACCESS } from '../../../shared/utility';
import { DROPDOWN_CONFIG, USER_SUBMENU_ID, Companyid } from '../../../shared/Config';
import FooterButton from '../../../shared/UI/FooterButton/FooterButton';
import * as actions from '../../../store/actions/index';

class AddStoreMaster extends Component {
    state = {
        type: 'add',
        Id: null,
        storeId: null,
        branch: '',
        storeCode: '',
        storeName: '',
        customerNumber: '',
        mobileNumber: '',
        email: '',
        address: '',
        city: '',
        state: '',
        pincode: '',
        isActive: false,
        // createdBy: (this.props.loggedUserDetail?.userName) ?? 'Admin',
        // createdDate: new Date(),
        CompanyId: this.props.loggedUserDetail?.CompanyId || Companyid,
        touch: false,
        // For dropdown options
        branchOptions: [],
        dataFetched: false
    }

    componentDidMount() {

        this.getAccess = HASACCESS(USER_SUBMENU_ID);

        this.props.getMasterKeywordList("Branch");

        const type = this.props.match.params.type;
        const id = this.props.match.params.id;

        this.setState({
            type
        });

        if (type !== "add") {
            this.fetchSingleProcess(id);
        }

    }

    // fetchSingleProcess = () => {
    //     let storeId = this.props.match.params.id;  // Using 'id' from params
    //     let companyId = this.props.loggedUserDetail?.CompanyId || Companyid;
    //     this.props.getMasterTableList(`res/GetInvStorebyid?storeid=${storeId}`, companyId);

    //     // Start timer to check when data is loaded
    //     this.startTimer();
    // }

    fetchSingleProcess = (id) => {

        this.props.getMasterTableList(
            `res/GetInvStorebyid?storeid=${id}`,
            this.state.CompanyId
        );

    }

    // startTimer = () => {
    //     this.intervalID = setInterval(() => {
    //         this.processFetchedData();
    //     }, 2000);
    // }

    // componentDidUpdate(prevProps) {
    //     // If tableLists changes and we haven't processed data yet
    //     if (this.props.tableLists !== prevProps.tableLists &&
    //         this.props.tableLists &&
    //         this.props.tableLists.length > 0 &&
    //         !this.state.dataFetched) {
    //         this.processFetchedData();
    //     }
    // }

    componentDidUpdate(prevProps) {

        if (
            this.props.tableLists &&
            this.props.tableLists !== prevProps.tableLists
        ) {

            const store = this.props.tableLists;

            this.setState({

                Id: store.storeId,

                storeId: store.storeId,

                branch: store.branchId,

                storeCode: store.storeCode,

                storeName: store.storeName,

                // isActive: store.isActive,

                CompanyId: store.companyid

            });

        }

    }

    componentWillUnmount() {
        if (this.intervalID) {
            clearInterval(this.intervalID);
        }
    }
    processFetchedData = () => {
        // Check if store data is available
        if (this.props.tableLists && this.props.tableLists.length > 0) {
            clearInterval(this.intervalID);

            // Get the first item (assuming single record)
            const storeData = this.props.tableLists[0] || this.props.tableLists;

            if (storeData) {
                // Map the API response to your state properties
                this.setState({
                    Id: storeData.storeId,
                    storeId: storeData.storeId,
                    branch: storeData.branchId, // Map branchId to branch
                    storeCode: storeData.storeCode || '',
                    storeName: storeData.storeName || '',
                    CompanyId: storeData.companyid || this.state.CompanyId,
                    // isActive: storeData.isActive || false
                });
            }
        }
    }

    change = (e) => {
        let { name, value, checked, type } = e.target;

        // Handle different input types
        if (type === 'checkbox' || type === 'switch') {
            this.setState({ [name]: checked, touch: true });
        } else {
            this.setState({ [name]: value, touch: true });
        }
    }

    // Handle dropdown change
    onDropdownChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value, touch: true });
    }

    // Validate and save store
    add = () => {
        let type = this.props.match.params.type;

        // Validate required fields
        const errors = [];
        if (!this.state.branch || this.state.branch === '') {
            errors.push('Branch is required');
        }
        if (!this.state.storeCode || this.state.storeCode.trim() === '') {
            errors.push('Store Code is required');
        }
        if (!this.state.storeName || this.state.storeName.trim() === '') {
            errors.push('Store Name is required');
        }

        if (errors.length > 0) {
            errors.forEach(error => {
                this.growl.show({ severity: 'error', summary: 'Validation Error', detail: error });
            });
            return;
        }

        // Prepare data for API
        const data = {
            storeCode: this.state.storeCode.trim(),
            storeName: this.state.storeName.trim(),
            branchId: this.state.branch,
            // isActive: this.state.isActive,
            CompanyId: this.state.CompanyId,
            // CreatedBy: this.state.createdBy,
            // CreatedDate: this.state.createdDate
        };

        // Add ID if editing
        if (type === 'edit' && this.state.Id) {
            data.Id = this.state.Id;
            data.storeId = this.state.storeId;
        }

        console.log('Submitting store data:', data);

        // Submit data - using 'Store' model and appropriate endpoint
        this.props.processDynamicData('invstore', type, data, 'res/GetInvStorebyid');
    }

    resetData = () => {
        this.setState({
            Id: null,
            storeId: null,
            branch: '',
            storeCode: '',
            storeName: '',
            customerNumber: '',
            mobileNumber: '',
            email: '',
            address: '',
            city: '',
            state: '',
            pincode: '',
            isActive: false,
            type: 'add',
            touch: false,
            dataFetched: false
        });
    }

    render() {
        // Redirect on success
        if (this.props.success) {
            REDIRECT_TO_URL('/store-master/', this.props);
        }

        // Check access permissions
        let addAccess = true;
        let editAccess = true;
        if (this.getAccess !== undefined) {
            if (this.getAccess.viewAccess === false) {
                this.props.history.push('/dashboard');
            }
            addAccess = this.getAccess.addAccess === true;
            editAccess = this.getAccess.editAccess === true;
        }
        let accessButton = { addAccess, editAccess };

        // Prepare branch dropdown options - FIXED
        // let branchOptions = [];
        // if (this.props.branch && Array.isArray(this.props.branch)) {
        //     branchOptions = this.props.branch.map(branch => ({
        //         label: branch.branchName || branch.name || branch,
        //         value: branch.branch || branch.id || branch.branch || branch
        //     }));
        // } else if (this.state.branch) {
        //     // If no options loaded but we have a value, add it as a fallback
        //     branchOptions = [{ label: this.state.branch, value: this.state.branch }];
        // }

        let isEnabled = this.state.touch === true;
        let redirectURL = '/store-master/';

        return (
            <div className="p-grid">
                {this.props.loading && <div className="page-loader"></div>}
                {this.props.error !== null && <Messages type="error" message={this.props.error} />}
                {this.props.success !== null && <Messages type="success" message={this.props.success} />}
                <Toast ref={(el) => this.growl = el} />
                <div className="p-col-12">
                    <div className="card card-w-title" style={{ position: 'relative' }}>
                        <h1>{this.state.type === 'edit' ? 'Edit' : this.state.type === 'view' ? 'View' : 'Add'} Store</h1>

                        <div className="p-grid mt1">
                            <div className="p-col-6 p-offset-3">
                                {/* Branch Dropdown */}
                                <div className="p-col-12">
                                    <label htmlFor="branch">Branch <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12">
                                    <Dropdown
                                        className="p-col-12"
                                        placeholder="Select Branch"
                                        options={this.props.branch}  // Use the mapped options
                                        value={this.state.branch}
                                        name="branch"
                                        onChange={this.onDropdownChange}
                                        {...DROPDOWN_CONFIG}
                                        disabled={this.state.type === 'view'}
                                    />
                                </div>

                                {/* Store Code */}
                                <div className="p-col-12">
                                    <label htmlFor="storeCode">Store Code <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12">
                                    <InputText
                                        className="p-col-12"
                                        name="storeCode"
                                        placeholder="Enter Store Code"
                                        value={this.state.storeCode}
                                        onChange={this.change}
                                        disabled={this.state.type === 'view'}
                                    />
                                </div>

                                {/* Store Name */}
                                <div className="p-col-12">
                                    <label htmlFor="storeName">Store Name <span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12">
                                    <InputText
                                        className="p-col-12"
                                        name="storeName"
                                        placeholder="Enter Store Name"
                                        value={this.state.storeName}
                                        onChange={this.change}
                                        disabled={this.state.type === 'view'}
                                    />
                                </div>

                                {/* Customer Number */}
                                {/* <div className="p-col-12">
                                    <label htmlFor="customerNumber">Customer Number</label>
                                </div>
                                <div className="p-col-12">
                                    <InputText
                                        className="p-col-12"
                                        name="customerNumber"
                                        placeholder="Enter Customer Number"
                                        value={this.state.customerNumber}
                                        onChange={this.change}
                                        disabled={this.state.type === 'view'}
                                    />
                                </div> */}

                                {/* Mobile Number */}
                                {/* <div className="p-col-12">
                                    <label htmlFor="mobileNumber">Mobile Number</label>
                                </div>
                                <div className="p-col-12">
                                    <InputText
                                        className="p-col-12"
                                        name="mobileNumber"
                                        placeholder="Enter Mobile Number"
                                        value={this.state.mobileNumber}
                                        onChange={this.change}
                                        disabled={this.state.type === 'view'}
                                    />
                                </div> */}

                                {/* Email */}
                                {/* <div className="p-col-12">
                                    <label htmlFor="email">Email</label>
                                </div>
                                <div className="p-col-12">
                                    <InputText
                                        className="p-col-12"
                                        name="email"
                                        placeholder="Enter Email"
                                        value={this.state.email}
                                        onChange={this.change}
                                        disabled={this.state.type === 'view'}
                                    />
                                </div> */}

                                {/* Address */}
                                {/* <div className="p-col-12">
                                    <label htmlFor="address">Address</label>
                                </div>
                                <div className="p-col-12">
                                    <InputText
                                        className="p-col-12"
                                        name="address"
                                        placeholder="Enter Address"
                                        value={this.state.address}
                                        onChange={this.change}
                                        disabled={this.state.type === 'view'}
                                    />
                                </div> */}

                                {/* City */}
                                {/* <div className="p-col-12">
                                    <label htmlFor="city">City</label>
                                </div>
                                <div className="p-col-12">
                                    <InputText
                                        className="p-col-12"
                                        name="city"
                                        placeholder="Enter City"
                                        value={this.state.city}
                                        onChange={this.change}
                                        disabled={this.state.type === 'view'}
                                    />
                                </div> */}

                                {/* State */}
                                {/* <div className="p-col-12">
                                    <label htmlFor="state">State</label>
                                </div>
                                <div className="p-col-12">
                                    <InputText
                                        className="p-col-12"
                                        name="state"
                                        placeholder="Enter State"
                                        value={this.state.state}
                                        onChange={this.change}
                                        disabled={this.state.type === 'view'}
                                    />
                                </div> */}

                                {/* Pincode */}
                                {/* <div className="p-col-12">
                                    <label htmlFor="pincode">Pincode</label>
                                </div>
                                <div className="p-col-12">
                                    <InputText
                                        className="p-col-12"
                                        name="pincode"
                                        placeholder="Enter Pincode"
                                        value={this.state.pincode}
                                        onChange={this.change}
                                        disabled={this.state.type === 'view'}
                                    />
                                </div> */}

                                {/* Status Switch */}
                                <div className="p-col-12">
                                    <label htmlFor="isActive">Status</label>
                                </div>
                                <div className="p-col-12">
                                    <InputSwitch
                                        checked={this.state.isActive}
                                        onChange={this.change}
                                        name="isActive"
                                        value={this.state.isActive}
                                        disabled={this.state.type === 'view'}
                                    />
                                </div>
                            </div>

                            <div className="p-col-12 p-lg-12">
                                <FooterButton
                                    access={accessButton}
                                    disabled={!isEnabled || this.state.type === 'view'}
                                    type={this.state.type.toLowerCase()}
                                    save={this.add}
                                    reset={this.resetData}
                                    to={redirectURL}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        loggedUserDetail: state.auth.userObject,
        userDetail: state.auth.userDetail,
        userPref: state.auth.userPref,
        loading: state.master.loading,
        error: state.master.error,
        success: state.master.success,
        tableLists: state.master.tableLists,
        branch: state.keyword.Branch
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getMasterTableList: (table, companyid) => dispatch(actions.getMasterTableList(table, companyid)),
        getMasterKeywordList: (value) => dispatch(actions.getMasterKeywordList(value)),
        fetchRelavantLists: (value) => dispatch(actions.fetchRelavantLists(value)),
        processDynamicData: (model, type, data, func) => dispatch(actions.processDynamicData(model, type, data, func)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AddStoreMaster);